/**
 * OdysseyModelEmitterBlendMode enum.
 * 
 * KotOR JS - A remake of the Odyssey Game Engine that powered KotOR I & II
 * 
 * @file OdysseyModelEmitterBlendMode.ts
 * @author KobaltBlu <https://github.com/KobaltBlu>
 * @license {@link https://www.gnu.org/licenses/gpl-3.0.txt|GPLv3}
 * @enum
 */
export enum OdysseyModelEmitterBlendMode {
  Normal = 'Normal',
  PunchThrough = 'Punch-Through', //Punch-Through|PunchThrough
  Lighten = 'Lighten',
}